import { Link, UIText1, UIText2 } from '@cian/ui-kit';
import { IconActionExternaLink12 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './VacancyItem.css';

interface IVacancyRealtorProps {
  vacancyLink: string;
  title: string;
  salary: string;
}

export const VacancyItem = ({ vacancyLink, title, salary }: IVacancyRealtorProps) => {
  if (!title) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <span className={styles['title']}>
        <UIText1 fontWeight="bold">{title}</UIText1>
        <Link
          href={vacancyLink}
          fontSize="S"
          beforeIcon={<IconActionExternaLink12 color="icon-main-default" />}
          target="_blank"
        />
      </span>
      <UIText2>{salary}</UIText2>
    </div>
  );
};
